// src/lib/wind/terrainMask.js
// Skysight terrain-RGB DEM, proxied at /api/forecast/terrain/{z}/{x}/{y}.webp.
// Unpack captured verbatim (docs/skysight-overlay-styles/wind/CAPTURE-NOTES.md,
// "Terrain masking"):  elev_m = R*6553.6 + G*25.6 + B*0.1 − 10000.
// Used to hide Wind-at-altitude streams where terrain rises above the level.

const TERRAIN_BASE = -10000;

// Elevation in metres from 0..255 RGB channels of one DEM pixel.
export const elevationFromRGB = (r, g, b) => r * 6553.6 + g * 25.6 + b * 0.1 + TERRAIN_BASE;

// Decode a tileCache RGBA tile ({ w, h, data }) → { w, h, elev: Float32Array }.
export const decodeTerrainGrid = (tile) => {
  const elev = new Float32Array(tile.w * tile.h);
  for (let i = 0; i < elev.length; i++) {
    const si = i * 4;
    elev[i] = elevationFromRGB(tile.data[si], tile.data[si + 1], tile.data[si + 2]);
  }
  return { w: tile.w, h: tile.h, elev };
};

// Lenient margin (m): wind is hidden only where terrain rises MORE than this
// above the selected level, so a launch sitting right at the level still shows
// wind (e.g. Drvar's ~742 m terrain at the 720 m level — only 22 m over — stays
// visible). Raise to mask more aggressively; 0 = strict `terrain ≥ level`.
export const TERRAIN_MASK_MARGIN_M = 100;

// The single hide/show rule, shared by every wind layer + the hover readout.
export const elevAboveLevel = (elev, maskLevel) => elev >= maskLevel + TERRAIN_MASK_MARGIN_M;

// True when the terrain at a tile-relative fraction (fracX/fracY in 0..1) is
// above maskLevel (+ margin) — i.e. the wind level is underground there. Scales
// the fraction into the grid's own resolution, so it is correct for any tile
// size (terrain tiles are 512² while wind/uv tiles render at 256²).
export const terrainAboveAtFrac = (grid, fracX, fracY, maskLevel) => {
  const gx = Math.min(grid.w - 1, Math.max(0, Math.floor(fracX * grid.w)));
  const gy = Math.min(grid.h - 1, Math.max(0, Math.floor(fracY * grid.h)));
  return elevAboveLevel(grid.elev[gy * grid.w + gx], maskLevel);
};
